//메뉴관리(ui_sfa_manage_001)

import React, { useRef, useState, useEffect, memo} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '@components/common/Layout';
import { showModal } from '@store/actions/commonAction';
import { Treebeard } from 'react-treebeard';
import { getToday } from '@common/utils/date';

import MenuSelect from '@components/menu/MenuSelect';
import MenuEdit from '@components/menu/MenuEdit';
import MenuInsert from '@components/menu/MenuInsert';

import MenuSelectBottom from '@components/menu/MenuSelectBottom';
import MenuEditBottom from '@components/menu/MenuEditBottom';
import MenuInsertBottom from '@components/menu/MenuInsertBottom';

import MenuUpDown from '@components/menu/MenuUpDown';

import {
    getApplicationFirstMenuList,
    getApplicationMenuList, 
    getApplicationMenuDetail, 
    saveApplicationMenu,
    updateSearchMenuInfo,    
    updateMenuInfo,
    getApplicationMenuExcelDown,
    updateSaveApplicationMenuInfoClear,
    saveApplicationMenuInfo,
    getMenuList,
    saveApplicationMenuUpDown,
    getApplicationMenuListSort,
    updateSearchMenuInfoClear
} from '@store/actions/menuAction';
import { render } from 'react-dom';


const MenuMain = () => {
    
    const dispatch = useDispatch();
    const { menuList, menuInfo, searchMenuInfo, saveMenuInfo, menuAllList} = useSelector(state => state.menuReducer);        
    const [menuSelectVisible, setMenuSelectVisible] = useState(false);
    const [menuEditVisible, setMenuEditVisible] = useState(false);
    const [menuInsertVisible, setMenuInsertVisible] = useState(false);    
    const [updownVisible, setUpdownVisible] = useState(false);    
    const [treeData, setTreeData] = useState({});
    const [cursor, setCursor] = useState({});
    const [selectMenuList, setSelectMenuList] = useState({});
    const [menuTitle, setTmenuTitle] = useState('메뉴관리');
    const menuIdRef = useRef();
    const menuNmRef = useRef();    
    const menuSortOrdRef = useRef();
    const linkUrlAddrRef = useRef();

    useEffect(() => {

        dispatch(updateSearchMenuInfoClear({
            deviceType: '01',
            aplctnTpCd:searchMenuInfo.aplctnTpCd,
            callback: handleSearchMenuInfoClearfunc
        }));         

    }, []);

    const handleSearchMenuInfoClearfunc = (data) => {
     
        dispatch(
            getApplicationFirstMenuList({
                aplctnDvcTyCd:'01'
            })
        );

        dispatch(
            getMenuList({
                aplctnTpCd:searchMenuInfo.aplctnTpCd,
                aplctnDvcTyCd:'01'
            })
        );       

        setMenuSelectVisible(true);       

    }

    //TREE 메뉴
    useEffect(() => {
        
        if(selectMenuList.length > 0) {
            selectMenuList[0].active = true;
            
            delete menuList["active"];

            if(menuList["children"]) {

                for(let i = 0; menuList["children"].length > i; i++) {                    
                    
                    if(menuList["children"][i]["menuId"] === selectMenuList[0].menuId) {
                        menuList["children"][i]["active"] = true;   //2depth
                    }

                    if(menuList["children"][i]["children"] !== undefined) {

                        for(let j = 0; menuList["children"][i]["children"].length > j; j++) {

                            if(menuList["children"][i]["children"][j]["menuId"] === selectMenuList[0].menuId) {
                                menuList["children"][i]["children"][j]["active"] = true;    //3depth
                            }

                            if(menuList["children"][i]["children"][j]["children"] !== undefined) {
                                
                                for(let k=0; menuList["children"][i]["children"][j]["children"].length > k; k++) {

                                    if(menuList["children"][i]["children"][j]["children"][k]["menuId"] === selectMenuList[0].menuId) {
                                        menuList["children"][i]["children"][j]["children"][k]["active"] = true;    //4depth
                                    }

                                }

                            }

                        }

                    }
                }
            }
            setTreeData(menuList);
        }else{
            setTreeData(menuList);
        }

    }, [menuList]);    

    useEffect(() => {
        if(searchMenuInfo.menuId != '') {
            dispatch(
                getApplicationMenuDetail()
            )
        }
    }, [searchMenuInfo.menuId]);

    const style = {
        tree: {
            base: {
                listStyle: 'none',
                backgroundColor: 'none',
                margin: 0,
                padding: 0,
                fontFamily: 'KBFGTextL, Apple SD Gothic Neo-Regular, Malgun Gothic, arial, sans-serif',
                fontSize: '14px',
                height: '100%'
            },
            node: {
                base: {
                    position: 'relative'
                },
                link: {
                    cursor: 'pointer',
                    position: 'relative',
                    padding: '0px 5px',
                    display: 'block'
                },
                activeLink: {
                    backgroundColor: '#fff9e0',
                    borderRadius: '1.2rem',
                    width:'37.6rem'
                },
                toggle: {
                    base: {
                        position: 'relative',
                        display: 'inline-block',
                        verticalAlign: 'top',
                        marginLeft: '-5px',
                        height: '24px',
                        width: '24px'
                    },
                    wrapper: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        margin: '-7px 0 0 -7px',
                        height: '14px'
                    },
                    height: 14,
                    width: 14,
                    arrow: {
                        fill: '#9DA5AB',
                        strokeWidth: 0
                    }
                }                
            },
        }
    }

    const onToggle = (node, toggled) => {

        clearActiveStyle(treeData);

        if(!menuInsertVisible) {

            if(cursor) {
                setCursor(() => ({ cursor, active: false}));
                cursor.active = false;
            }

            node.active = true;            
            node.toggled = toggled;
            
            setCursor(() => ({ cursor : node, data:Object.assign({}, treeData)}));
    
            dispatch(
                updateSearchMenuInfo({
                  ...searchMenuInfo,
                  menuId: node.menuId,
                  aplctnTpCd: node.aplctnTpCd,
                  upMenuId: node.upMenuId === null ? node.menuId : node.upMenuId
               }),
            );

        }       
        
    };  

    const clearActiveStyle = (tree) => {

        if(tree.hasOwnProperty('active')) {            
            delete tree["active"];
        }else{
            if(tree["children"]) {
                for(let i = 0; tree["children"].length > i; i++) {
                    
                    delete tree["children"][i]["active"];
                    
                    if(tree["children"][i]["children"] !== undefined) {
                        for(let j = 0; tree["children"][i]["children"].length > j; j++) {
                       
                            delete tree["children"][i]["children"][j]["active"];

                            if(tree["children"][i]["children"][j] !== undefined) {
                                
                                if(tree["children"][i]["children"][j]["children"] !== undefined) {
                                
                                    for(let k=0; tree["children"][i]["children"][j]["children"].length > k; k++) {
                                
                                        delete tree["children"][i]["children"][j]["children"][k]["active"];
                                    }    
                                }
                            }
                        }
                    }
                }
            }
        }
    };

    const handleDeviceType = type => {
        dispatch(
           updateSearchMenuInfo({
            ...searchMenuInfo,   
            deviceType: type,
          }),
        );
    };

    const searchMenuList = () => {        
        
        dispatch(
            updateSearchMenuInfo({
                ...searchMenuInfo,
                searchDeviceType: searchMenuInfo.deviceType,
           }),
        );
        
        dispatch(getApplicationMenuList({aplctnDvcTyCd:searchMenuInfo.deviceType}));
        setSelectMenuList({}); //트리메뉴 선택부분 초기화
        
        dispatch(
            getMenuList({
                aplctnTpCd:searchMenuInfo.aplctnTpCd,
                aplctnDvcTyCd:searchMenuInfo.deviceType
            })
        )        
    }

    //메뉴 추가
    let max;
    let maxSortOrdr;
    const menuInsert = type => {
        
        const list = menuAllList.filter(item => item.menuId === menuInfo.menuId);
        const vMenuIds = menuAllList.filter(item => item.pmenuID === list[0].vmenuID);       
        
        if(vMenuIds.length === 0) {

            let newId;
            let UpDepth;

            if((menuInfo.menuId.length - list[0].vmenuID.length) === 4) {
                newId = list[0].vmenuID + '1000';
                UpDepth = menuInfo.depth;
            }else if((menuInfo.menuId.length - list[0].vmenuID.length) === 2) {
                newId = list[0].vmenuID + '10';
                UpDepth = menuInfo.depth;
            }else{
                newId = menuInfo.menuId.substr(0, menuInfo.menuId.length-1) + parseInt(menuInfo.menuId.substring(menuInfo.menuId.length-1)+1);
                UpDepth = menuInfo.depth;
            }

            dispatch(
                saveApplicationMenuInfo({
                    ...saveMenuInfo,
                    depth: UpDepth+1,
                    menuId:newId,
                    menuSortOrd:1
                }),
            );

        }else{            
    
            const firstMenuList = vMenuIds.map( item => Object.assign(item, { menuNewId: item.menuId.replace(list[0].vmenuID,'') } ));
            max = firstMenuList[0].menuNewId.substring(0,1).charCodeAt(0);            
            maxSortOrdr = firstMenuList[0].menuSortOrd;

            for(let i=1; firstMenuList.length > i ;i++) {
                if(max < firstMenuList[i].menuNewId.charCodeAt(0)) {
                    max = firstMenuList[i].menuNewId.charCodeAt(0);
                }

                if(maxSortOrdr < firstMenuList[i].menuSortOrd) {
                    maxSortOrdr = firstMenuList[i].menuSortOrd;
                }
            }

            let menuIdId = 0;
            
            //유니코드 57은 숫자9, 다음 A로 시작하기 위해 8더함
            if(max === 57) {    
                menuIdId = list[0].vmenuID + String.fromCharCode(max+8);
            }else{
                menuIdId = list[0].vmenuID + String.fromCharCode(max+1);
            }

            const newId = menuIdId.padEnd(list[0].menuId.length, "0");
            
            let UpDepth = menuInfo.depth;
            
            dispatch(
                saveApplicationMenuInfo({
                    ...saveMenuInfo,
                    depth: UpDepth+1,
                    menuId:newId,
                    menuSortOrd:maxSortOrdr+1
                }),
            );
        }

        setTmenuTitle('메뉴등록');
        setMenuSelectVisible(false),
        setMenuEditVisible(false),
        setMenuInsertVisible(true)
        setUpdownVisible(false)
    }


    //메뉴 수정
    const menuEdit = () => {        

        dispatch(
            getMenuList({
                aplctnTpCd:searchMenuInfo.aplctnTpCd,
                aplctnDvcTyCd:searchMenuInfo.deviceType
            })
        );

        setTmenuTitle('메뉴수정');
        setMenuSelectVisible(false),
        setMenuEditVisible(true),
        setMenuInsertVisible(false),
        setUpdownVisible(true)
    }
    

    //엑셀다운로드
    const excelDown = () => {
        
        const today = getToday('yyyyMMddHHmm');

        dispatch(
            getApplicationMenuExcelDown(
                {
                    aplctnDvcTyCd:searchMenuInfo.deviceType,
                    excelFileName : '메뉴관리_'+today+'.xlsx'
                }
            )
        )
    }

    const insertValidation = () => {

        if(saveMenuInfo.menuId === '' || saveMenuInfo.menuId === null) {
            dispatch(
                showModal({
                  visible: true,
                  type: 'info',
                  msg: '메뉴ID가 없습니다.',
                  onOk: {                    
                    handle: () => menuIdRef.current.onFocus()
                  }
                }),
              );
              return false;
        }else if(saveMenuInfo.menuNm === '' || saveMenuInfo.menuNm === null) {
            dispatch(
                showModal({
                  visible: true,
                  type: 'info',
                  msg: '메뉴명이 없습니다.',
                  onOk: {                    
                    handle: () => menuNmRef.current.onFocus()
                  }
                }),
              );              
            return false;
        // }else if(saveMenuInfo.menuSortOrd === 0) {
        //     dispatch(
        //         showModal({
        //           visible: true,
        //           type: 'info',
        //           msg: '메뉴순서가 없습니다.',
        //           onOk: {                    
        //             handle: () => menuSortOrdRef.current.onFocus()
        //           }
        //         }),
        //       );              
        //     return false;
        }else if(saveMenuInfo.linkMenuYn === 'Y' && (saveMenuInfo.linkUrlAddr === '' || saveMenuInfo.linkUrlAddr === null)) {
            dispatch(
                showModal({
                  visible: true,
                  type: 'info',
                  msg: '링크URL이 없습니다.',
                  onOk: {                    
                    handle: () => linkUrlAddrRef.current.onFocus()
                  }
                }),
              );
            return false;
        }
        return true;
    }

    const updateValidation = () => {
        
        if(menuInfo.menuId === '' || menuInfo.menuId === null) {
            dispatch(
                showModal({
                  visible: true,
                  type: 'info',
                  msg: '메뉴ID가 없습니다.',
                  onOk: {                    
                    handle: () => menuIdRef.current.onFocus()
                  }
                }),
              );
              return false;
        }else if(menuInfo.menuNm === '' || menuInfo.menuNm === null) {
            dispatch(
                showModal({
                  visible: true,
                  type: 'info',
                  msg: '메뉴명이 없습니다.',
                  onOk: {                    
                    handle: () => menuNmRef.current.onFocus()
                  }
                }),
              );              
            return false;
        // }else if(menuInfo.menuSortOrd === 0) {
        //     dispatch(
        //         showModal({
        //           visible: true,
        //           type: 'info',
        //           msg: '메뉴순서가 없습니다.',
        //           onOk: {                    
        //             handle: () => menuSortOrd.current.onFocus()
        //           }
        //         }),
        //       );              
        //     return false;
        }else if(menuInfo.linkMenuYn === 'Y' && (menuInfo.linkUrlAddr === '' || menuInfo.linkUrlAddr === null)) {
            dispatch(
                showModal({
                  visible: true,
                  type: 'info',
                  msg: '링크URL이 없습니다.',
                  onOk: {                    
                    handle: () => linkUrlAddrRef.current.onFocus()
                  }
                }),
              );
            return false;
        }
        return true;
    }

    //수정 저장버튼 클릭
    const saveBtn = () => {
        
        if (updateValidation()) {
            
            dispatch(
              updateMenuInfo({
                upMenuId: searchMenuInfo.upMenuId,
              }),
            );
            
            dispatch(
                saveApplicationMenu({
                    ...menuInfo,
                    callback: handleVerifyCallcakfunc,
                })                
            );
        }
    }   

    const handleVerifyCallcakfunc = (status, type) => {
        
        if(status === 200) {

            dispatch(
                 getApplicationMenuList({
                     //aplctnDvcTyCd:searchMenuInfo.deviceType
                     aplctnDvcTyCd:searchMenuInfo.searchDeviceType
                 })
            )    

            dispatch(
                updateSearchMenuInfo({
                 ...searchMenuInfo,   
                 deviceType: searchMenuInfo.searchDeviceType,
               }),
             );

            dispatch(
                updateSaveApplicationMenuInfoClear()
            )

            setMenuSelectVisible(true),
            setMenuEditVisible(false),
            setMenuInsertVisible(false),
            setUpdownVisible(false)

        }

    };

    //등록 저장버튼 클릭
    const insertBtn = () => {

        if (insertValidation()) {           
            dispatch(
                saveApplicationMenu({
                   ...saveMenuInfo,
                   upMenuId : menuInfo.menuId,
                   callback: handleVerifyCallcakfunc,
                })
            )            
        }
    }

    //취소버튼 클릭
    const cancelBtn = () => {

        dispatch(
            getApplicationFirstMenuList({
                aplctnDvcTyCd:searchMenuInfo.searchDeviceType
            })
        )

        dispatch(
            updateSaveApplicationMenuInfoClear()
        )
        
        setTmenuTitle('메뉴관리');
        setMenuSelectVisible(true),
        setMenuEditVisible(false),
        setMenuInsertVisible(false),
        setUpdownVisible(false),
        clearActiveStyle(menuList);
        setSelectMenuList({}); 
    }

    const updownClick = (type) => {        

        let result;
        let menuSortOrd = menuInfo.menuSortOrd; //선택한 메뉴의 메뉴순서
        let oldMenuSortOrd = menuInfo.menuSortOrd;

        const firstMenuList = menuAllList.filter(item => item.menuId === menuInfo.menuId);
        const secondMenuList = menuAllList.filter(item => item.pmenuID === firstMenuList[0].pmenuID);        
        const thirdMenuList = secondMenuList.filter(item => item.menuId != menuInfo.menuId);

        setSelectMenuList(firstMenuList);
        
        if(parseInt(menuInfo.depth) === 1) {

            dispatch(
                showModal({
                    visible: true,
                    type: 'info',
                    msg: '최상단 메뉴는 메뉴순서를 변경할수 없습니다.',
                })
            );

        }else{

            if(type === 'up') {

                let min = menuSortOrd; //100

                for(let i=0; thirdMenuList.length > i; i++) {
                    if(min > thirdMenuList[i].menuSortOrd) {
                        min = thirdMenuList[i].menuSortOrd;
                    }
                }

                if(menuSortOrd === min) {
                    dispatch(
                        showModal({
                            visible: true,
                            type: 'info',
                            msg: '메뉴순서가 최상위 입니다.',
                        })
                    );
                }else{

                    if(menuSortOrd === 0) {
                        menuSortOrd = parseInt(menuSortOrd);
                    }else{    
                        if(parseInt(menuSortOrd) > 1) {
                            menuSortOrd = parseInt(menuSortOrd) - 1;
                        }else{
                            menuSortOrd = 0;
                        }                
                    }
    
                    result = thirdMenuList.map(item => Object.assign(item, {menuSortOrd: parseInt(item.menuSortOrd) === menuSortOrd ?  parseInt(item.menuSortOrd) +1 :  parseInt(item.menuSortOrd), upMenuId: item.pmenuID.padEnd(item.menuId.length, "0")}));
                    result = result.map(item => Object.assign(item, {menuSortOrd: parseInt(item.menuSortOrd) < menuSortOrd ?  parseInt(item.menuSortOrd)  :  parseInt(item.menuSortOrd), upMenuId: item.pmenuID.padEnd(item.menuId.length, "0")}));
                    result = result.map(item => Object.assign(item, {menuSortOrd: parseInt(item.menuSortOrd) > menuSortOrd ?  parseInt(item.menuSortOrd)  :  parseInt(item.menuSortOrd), upMenuId: item.pmenuID.padEnd(item.menuId.length, "0")}));

                    dispatch(
                        updateMenuInfo({
                        ...menuInfo,
                        menuSortOrd: menuSortOrd,
                      }),
                    );
            
                    dispatch(
                        saveApplicationMenuUpDown({
                            ...menuInfo,
                            result : result,
                            order : menuSortOrd,
                            callback: handleVerifyCallcakfuncSave,
                        })
                    );
        
                }
                
            }else{

                let max = menuSortOrd; //110

                for(let i=0; thirdMenuList.length > i; i++) {
                    if(max < thirdMenuList[i].menuSortOrd) {
                        max = thirdMenuList[i].menuSortOrd;
                    }
                }

                if(max === menuSortOrd) {

                    dispatch(
                        showModal({
                            visible: true,
                            type: 'info',
                            msg: '메뉴순서가 최하위 입니다.',
                        })
                    );

                }else{
                    menuSortOrd = parseInt(menuSortOrd) + 1;
    
                    result = thirdMenuList.map(item => Object.assign(item, {menuSortOrd: parseInt(item.menuSortOrd) === oldMenuSortOrd ?  parseInt(item.menuSortOrd) + 1:  parseInt(item.menuSortOrd), upMenuId: item.pmenuID.padEnd(item.menuId.length, "0")}));
                    result = result.map(item => Object.assign(item, {menuSortOrd: parseInt(item.menuSortOrd) < oldMenuSortOrd ?  parseInt(item.menuSortOrd)  :  parseInt(item.menuSortOrd), upMenuId: item.pmenuID.padEnd(item.menuId.length, "0")}));
                    result = result.map(item => Object.assign(item, {menuSortOrd: parseInt(item.menuSortOrd) === menuSortOrd ?  parseInt(item.menuSortOrd) - 1  :  parseInt(item.menuSortOrd), upMenuId: item.pmenuID.padEnd(item.menuId.length, "0")}));
                    result = result.map(item => Object.assign(item, {menuSortOrd: parseInt(item.menuSortOrd) > menuSortOrd ?  parseInt(item.menuSortOrd) :  parseInt(item.menuSortOrd), upMenuId: item.pmenuID.padEnd(item.menuId.length, "0")}));
    
                    dispatch(
                        updateMenuInfo({
                        ...menuInfo,
                        menuSortOrd: menuSortOrd,
                      }),
                    );
            
                    dispatch(
                        saveApplicationMenuUpDown({
                            ...menuInfo,
                            result : result,
                            order : menuSortOrd,
                            callback: handleVerifyCallcakfuncSave,
                        })
                    );    
                }

            }       
           
        }
    }

    const handleVerifyCallcakfuncSave = (status, data) => {        
        
        if(status === 200) {
             dispatch(
                getApplicationMenuListSort({
                     aplctnDvcTyCd:searchMenuInfo.deviceType
                 })
            )    

            dispatch(
                updateSearchMenuInfo({
				  ...searchMenuInfo,
                  menuId: data.menuId,                  
               }),
            );

            dispatch(
                updateSaveApplicationMenuInfoClear()
            )
        }
    };

    const handleDelCallcakfunc = (status, data) => {
        if(status === 200) {

            dispatch(
                showModal({
                    visible: true,
                    type: 'info',
                    msg: '삭제되었습니다.',
                })
            );

            dispatch(
                getApplicationFirstMenuList({
                    aplctnDvcTyCd:searchMenuInfo.deviceType
                })
            )
    
            dispatch(
                updateSaveApplicationMenuInfoClear()
            )
    
            setMenuSelectVisible(true),
            setMenuEditVisible(false),
            setMenuInsertVisible(false),
            setUpdownVisible(false)
            
        }
    };

    return (        
        <React.Fragment>
            <Layout>                
                <div className="content manage-content">
                    <div className="con-wrap">
                        <div className="app-wrap">
                            <div className="app-box">
                                <div className="con-bottom">
                                    <div className="tit-area">
                                        <h2 className="tit-con">{menuTitle}</h2>
                                    </div>
                                
                                    <div className="search-box mgt-0">
                                        <div className="check-box">
                                            <span className="title">디바이스</span>
                                            <div className="check-wrap">
                                                <input type="radio" name="chk01" id="chk01" checked={searchMenuInfo.deviceType === '01'} 
                                                onChange={() =>
                                                    searchMenuInfo.deviceType !== '01' && handleDeviceType('01')
                                                } /><label htmlFor="chk01">PC</label> 
                                            </div>
                                            <div className="check-wrap">
                                                <input type="radio" name="chk01" id="chk02" checked={searchMenuInfo.deviceType === '02'} 
                                                    onChange={ () => searchMenuInfo.deviceType !== '02' && handleDeviceType('02') }/>
                                                <label htmlFor="chk02">테블릿</label>
                                            </div>
                                            <div className="check-wrap">
                                                <input type="radio" name="chk01" id="chk03" checked={searchMenuInfo.deviceType === '03'} 
                                                    onChange={ () => searchMenuInfo.deviceType !== '03' && handleDeviceType('03') }/>                                                
                                                <label htmlFor="chk03">모바일</label>
                                            </div>
                                        </div>
                                        <button className="btn-search"  onClick={searchMenuList}>검색</button>
                                    </div>
                                
                                    <div className="col-tbl-wrap">                                    
                                        <div className="table-wrap-reg">
                                            <div className="menu-index">
                                                <div className="title">메뉴목록</div>
                                                <div className="tree-wrap">                                                   
                                                    <Treebeard data={treeData} style={style} onToggle={onToggle} />
                                                </div>
                                            </div>                                           
                                            <MenuUpDown visible={updownVisible} updownClick={updownClick} />
                                        </div>
                                        <MenuSelect visible={menuSelectVisible} menuInfo={menuInfo} />
                                        <MenuEdit visible={menuEditVisible} menuEdit={menuEdit} menuInfo={menuInfo} menuSortOrdRef={menuSortOrdRef} menuIdRef={menuIdRef} menuNmRef={menuNmRef} linkUrlAddrRef={linkUrlAddrRef} />
                                        <MenuInsert visible={menuInsertVisible}  menuInfo={menuInfo} menuSortOrdRef={menuSortOrdRef} menuIdRef={menuIdRef} menuNmRef={menuNmRef} linkUrlAddrRef={linkUrlAddrRef} />
                                    </div>
                                </div>
                                    <MenuSelectBottom visible={menuSelectVisible} menuInsert={menuInsert} menuEdit={menuEdit} excelDown={excelDown} />
                                    <MenuEditBottom visible={menuEditVisible} menuEdit={menuEdit} menuInfo={menuInfo} saveBtn={saveBtn} cancelBtn={cancelBtn} handleDelCallcakfunc={handleDelCallcakfunc} />
                                    <MenuInsertBottom visible={menuInsertVisible} insertBtn={insertBtn} cancelBtn={cancelBtn} />
                            </div>
                        </div>
                    </div>
                </div>	            
            </Layout>
        </React.Fragment>
       
    );
};

export default memo(MenuMain);